// eslint-disable-next-line import/prefer-default-export
export const BillboardViewType = Object.freeze({
    Calendar: 'month',
    List: 'list',
});
